import { register as registerSwiperElements } from 'swiper/element/bundle'
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr} from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

registerSwiperElements();
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    provideAnimations(), 
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
    }), provideAnimationsAsync('noop'),
  ],
}).catch((err) => console.error(err));